/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeLocation } from '../../models/employee-location';

export interface GetEmployeeLocation$Plain$Params {

/**
 * The employee location ID
 */
  id: number;
}

export function getEmployeeLocation$Plain(http: HttpClient, rootUrl: string, params: GetEmployeeLocation$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeLocation>> {
  const rb = new RequestBuilder(rootUrl, getEmployeeLocation$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmployeeLocation>;
    })
  );
}

getEmployeeLocation$Plain.PATH = '/api/EmployeeLocation/{id}';
